module.exports = __webpack_public_path__ + "img/ArrowLeft.43585f76.svg";